// ToReviewList.js
// "To review" card: the up-to-3 soonest-closing published tests, each with
// its grading state. Renders null when there is nothing to review.
//
// Deviation from spec §5: the spec's prose gives this card a header action
// "All tests", but its declared prop list (`items, onGradeTest, onEditTest,
// isDarkMode, t`) has no callback for it — unlike AttentionList, which does
// get `onOpenDashboard` for the same kind of header link. Rather than invent
// a handler, this adds an optional `onViewAll` prop (default null): the
// header action only appears once a caller wires one in.
// See docs/superpowers/specs/2026-09-16-home-redesign.md §4/§5.
import React from "react";

import HomeCard from "../primitives/HomeCard";
import HomeRow from "../primitives/HomeRow";
import { weekdayShort } from "../homeTime";

const identity = (s) => s;

const buildSubtitle = (item, t) => {
  if (item.needsMark > 0) {
    return t("{count} need a mark · closes {weekday}", {
      count: item.needsMark,
      weekday: t(weekdayShort(item.closes)),
    });
  }
  return t("{count} not submitted", { count: item.notSubmitted });
};

const ToReviewList = ({
  items = [],
  onGradeTest,
  onEditTest,
  onViewAll = null,
  isDarkMode = false,
  t = identity,
}) => {
  if (!items || items.length === 0) return null;

  return (
    <HomeCard
      title={t("To review")}
      action={onViewAll ? { label: t("All tests"), onPress: onViewAll } : null}
      isDarkMode={isDarkMode}
      testID="to-review-list"
    >
      {items.map((item, index) => {
        const needsGrade = item.needsMark > 0;
        return (
          <HomeRow
            key={item.test?.id ?? index}
            title={t("{title} · {count} responses", {
              title: item.test?.title || "",
              count: item.submitted,
            })}
            subtitle={buildSubtitle(item, t)}
            action={{
              label: needsGrade ? t("Grade") : t("Edit"),
              onPress: () =>
                needsGrade ? onGradeTest?.(item.test) : onEditTest?.(item.test),
              primary: needsGrade,
            }}
            isDarkMode={isDarkMode}
            first={index === 0}
            testID={`to-review-row-${index}`}
          />
        );
      })}
    </HomeCard>
  );
};

export default ToReviewList;
